import * as React from "react";

const FirstPage: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
            <path
                d="M7.95946 0.5L3.5888 5L7.95946 9.5L8.5 8.93551L4.67761 5L8.5 1.06449L7.95946 0.5ZM4.87066 0.5L0.5 5L4.87066 9.5L5.4112 8.93551L1.5888 5L5.4112 1.06449L4.87066 0.5Z"
                fill="#535353"
            />
        </svg>
    );
};

export default React.memo(FirstPage);
